import { getTheMartianWishes, sendTheMartianWish } from '../_actions/wishes'
import { TTheMartianWish } from '@/types/the-martian'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

const THE_MARTIAN_WISHES_KEY = ['the-martian-wishes']

/** initialData lấy từ server để render ngay, không bị nháy/nhảy layout */
export const useTheMartianWishes = (initialData: TTheMartianWish[]) => {
  return useQuery({
    queryKey: THE_MARTIAN_WISHES_KEY,
    queryFn: () => getTheMartianWishes(),
    initialData,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  })
}

export const useSendTheMartianWishMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['mutation.the-martian-wish'],
    mutationFn: async (body: Parameters<typeof sendTheMartianWish>[0]) => {
      const { success } = await sendTheMartianWish(body)
      if (!success) throw new Error('Send wish failed')
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: THE_MARTIAN_WISHES_KEY })
    },
  })
}
